import { useMemo } from 'react';
import { parsePostText } from '$utils';

export const useParseText = (text: string) => {
  return useMemo(() => {
    return parsePostText(text);
  }, [text]);
};
